import React from 'react';
import config from "../../config/config";
import * as moment from 'moment';
import * as _ from 'lodash';
import routes from "../../utils/api-client";

const UPDATE_USER = "UPDATE_USER";
const UPDATE_TOKEN = "UPDATE_TOKEN";
const UPDATE_CLIENT = "UPDATE_CLIENT";

export const updateToken = (token) => ({
  type: UPDATE_TOKEN,
  payload: { token }
});

export const updateUser = (auth0User, userData) => ({
  type: UPDATE_USER,
  payload: { auth0User, userData }
});

export const updateClient = (clientData) => ({
  type: UPDATE_CLIENT,
  payload: { clientData }
});

const initialState = {
  user: null,
  token: null
};

export default function(state=initialState, action) {
  switch (action.type) {
    case UPDATE_TOKEN:
      const { token } = action.payload;
      return {
        ...state,
        token: token
      };

    case UPDATE_CLIENT:
      const { clientData } = action.payload;
      const newUser = state.user
      newUser.clients[clientData.id] = clientData;
      return {
        ...state,
        user: newUser
      };

    case UPDATE_USER:
      const { auth0User, userData } = action.payload;

      if (auth0User && userData) {
        window.drift.identify(auth0User['sub'], {
          email: userData.email,
          name: userData.name
        });

        let user = {
          emailVerified: _.get(auth0User, 'email_verified', false),
          email: _.get(userData, 'email', ''),
          id: _.get(userData, 'id', ''),
          name: _.get(userData, 'name', ''),
          type: _.get(userData, 'type', 'INDIVIDUAL'),
          advisors: _.get(userData, 'advisors', ''),
          clients: _.get(userData, 'clients', {}),
          company: _.get(userData, 'company', ''),
          subscriptionEnds: _.get(userData, 'subscription_ends', ''),
          subscriptionStarted: _.get(userData, 'subscription_started', ''),
          subscriptionType: _.get(userData, 'subscription_type', ''),
          subscriptionStatus: _.get(userData, 'subscription_status', ''),
          vaultArchiveDate: _.get(userData, 'vault_archive_date', ''),
          frozen: false,
        };

        // determine subscription status & check for trial expiration
        switch(user.subscriptionType) {
          case 'FREE_TRIAL':
            const trialDaysRemaining = moment.duration(moment(user.subscriptionEnds).diff(moment()));
            user['trialDaysRemaining'] = trialDaysRemaining.asMilliseconds() < 0 ? 0 : trialDaysRemaining.days() + 1 ;

            if (moment() > moment(user.subscriptionEnds)) {
              user.subscriptionStatus = 'FREE_TRIAL_ENDED';
              user.frozen = true;
            } else if (moment().add(7, "days") > moment(user.subscriptionEnds)) {
              user.subscriptionStatus = 'FREE_TRIAL_ENDS_SOON';
            } else {
              user.subscriptionStatus = 'ACTIVE';
            }
            break;
          case 'ANNUAL':
          case 'MONTHLY':
            if (user.subscriptionStatus !== "ACTIVE") {
              // subscription expired
              user.frozen = true;
            }
            break;
        }

        return {
          ...state,
          user: user,
        };
      }

    default:
      return state;
  }
}